// import React, { useState } from "react";
// import "../assets/css/GrtTraining.css";

// const WealthOfficerGRT = () => {
//   const [formData, setFormData] = useState({
//     wealthOfficer: "",
//     center: "",
//     group: "",
//     member: "",
//     remark: "",
//     grtDate: "",
//     addDocuments: false,
//   });
  

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Form Data:", formData);
//     alert("GRT record added successfully!");
//   };

//   return (
//     <div className="grtTraining-container">
//       <h2 className="grtTraining-title">Wealth Officer GRT Entry</h2>
//       <form className="grtTraining-form" onSubmit={handleSubmit}>
//         {/* First Row */}
//         <div className="grtTraining-grid">
//           <div className="grtTraining-field">
//             <label>Wealth Officer</label>
//             <select
//               name="wealthOfficer"
//               value={formData.wealthOfficer}
//               onChange={handleChange}
//             >
//               <option value="">Select Wealth Officer</option>
//               <option value="officer1">Officer 1</option>
//               <option value="officer2">Officer 2</option>
//             </select>
//           </div>

//           <div className="grtTraining-field">
//             <label>Center</label>
//             <input
//               type="text"
//               name="center"
//               value={formData.center}
//               onChange={handleChange}
//               placeholder="Enter Center"
//             />
//           </div>
//         </div>

//         {/* Second Row */}
//         <div className="grtTraining-grid">
//           <div className="grtTraining-field">
//             <label>Select Group</label>
//             <select
//               name="group"
//               value={formData.group}
//               onChange={handleChange}
//             >
//               <option value="">Select Group</option>
//               <option value="group1">Group 1</option>
//               <option value="group2">Group 2</option>
//             </select>
//           </div>

//           <div className="grtTraining-field">
//             <label>Group Members</label>
//             <select
//               name="member"
//               value={formData.member}
//               onChange={handleChange}
//             >
//               <option value="">Select Group Member</option>
//               <option value="member1">Member 1</option>
//               <option value="member2">Member 2</option>
//             </select>
//           </div>
//         </div>

//         {/* Third Row */}
//         <div className="grtTraining-grid">
//           <div className="grtTraining-field">
//             <label>Remark</label>
//             <input
//               type="text"
//               name="remark"
//               value={formData.remark}
//               onChange={handleChange}
//               placeholder="Remark"
//             />
//           </div>

//           <div className="grtTraining-field">
//             <label>GRT Date</label>
//             <input
//               type="date"
//               name="grtDate"
//               value={formData.grtDate}
//               onChange={handleChange}
//             />
//           </div>
//         </div>

//         {/* Checkbox */}
//         <div className="grtTraining-checkbox">
//           <input
//             type="checkbox"
//             name="addDocuments"
//             checked={formData.addDocuments}
//             onChange={handleChange}
//           />
//           <label>If you want to add GRT Documents</label>
//         </div>

//         {/* Button */}
//         <div className="grtTraining-btn-container">
//           <button type="submit" className="grtTraining-btn">
//             Add
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default WealthOfficerGRT;


// ------------------------------------


import React, { useState } from "react";
import "../assets/css/GrtTraining.css";
import { toast } from "react-toastify";

const WealthOfficerGRT = () => {
  const [formData, setFormData] = useState({
    wealthOfficer: "",
    center: "",
    group: "",
    member: "",
    remark: "",
    grtDate: "",
    addDocuments: false,
  });


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
    toast.success("GRT record added successfully!");
  };
  return (
    <div className="grt-training-container">
      <h1 className="grt-training-heading">Wealth Officer GRT Entry</h1>

      {/* ================= FORM ================= */}
      <section className="grt-training-top">
        <form className="grt-training-form" onSubmit={handleSubmit}>
          <div className="grt-training-form-section">
            <div className="grt-training-form-input-fields">
               <label>Wealth Officer</label>
             <select
              name="wealthOfficer"
              value={formData.wealthOfficer}
              onChange={handleChange}
            >
              <option value="">Select Wealth Officer</option>
              <option value="officer1">Officer 1</option>
              <option value="officer2">Officer 2</option>
            </select>
            </div>

            <div className="grt-training-form-input-fields">
               <label>Center</label>
            <input
              type="text"
              name="center"
              value={formData.center}
              onChange={handleChange}
              placeholder="Enter Center"
            />
            </div>

            <div className="grt-training-form-input-fields">
            <label>Select Group</label>
             <select
              name="group"
              value={formData.group}
              onChange={handleChange}
            >
              <option value="">Select Group</option>
              <option value="group1">Group 1</option>
              <option value="group2">Group 2</option>
            </select>
            </div>

            <div className="grt-training-form-input-fields">
              <label>Group Members</label>
             <select
              name="member"
              value={formData.member}
              onChange={handleChange}
            >
              <option value="">Select Group Member</option>
              <option value="member1">Member 1</option>
              <option value="member2">Member 2</option>
            </select>
            </div>

            <div className="grt-training-form-input-fields">
               <label>Remark</label>
             <input
              type="text"
              name="remark"
              value={formData.remark}
              onChange={handleChange}
              placeholder="Remark"
            />
            </div>

            <div className="grt-training-form-input-fields">
             <label>GRT Date</label>
             <input
              type="date"
              name="grtDate"
              value={formData.grtDate}
              onChange={handleChange}
            />
            </div>
          </div>

            <div className="grt-training-checkbox">
             <input
            type="checkbox"
            name="addDocuments"
            checked={formData.addDocuments}
            onChange={handleChange}
          />
          <label>If you want to add GRT Documents</label>
            </div>
          <div className="grt-training-form-submit-btn">
             <button>Add</button>
          </div>
        </form>
      </section>
    </div>
  );
};

export default WealthOfficerGRT;

